module.exports = __webpack_public_path__ + "img/boxing.0945beff.svg";